<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
    [interactionMode]="'selection'"
    [selection]="propertyConfig"
    (selectionChange)="onSelectionChange($event)"
  >
    <elder-data-toolbar *elderTableToolbar [canAdd]="false" [canRemove]="false" [canMore]="false">
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
      <td mat-cell *matCellDef>
        <mat-icon>label</mat-icon>
      </td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let pp">{{ pp.description }}</td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 70%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let pp">{{ pp.id }}</td>
    </ng-container>
  </elder-table>
</div>
